// // src/components/checkAddress.jsx
// import React, { useState, useEffect } from 'react';
// import { backendUrl } from './config';
// import { makeStyles } from '@mui/styles';
// import { TextField, Typography, Paper, List, ListItem } from '@mui/material';

// const useStyles = makeStyles(() => ({
//     formField: {
//         marginBottom: '3px !important',
//         width: '100%',
//     },
//     errorText: {
//         fontSize: (props) => (props.fontSizeVariant === 'small' ? '0.75rem' : '0.85rem'),
//         marginTop: '1px',
//     },
// }));

// const AddressCheck = ({ onAddressSelect, fontSizeVariant = "regular", initialAddress = "" }) => {
//     const classes = useStyles({ fontSizeVariant });
//     const [addressInput, setAddressInput] = useState(initialAddress);
//     const [selectedAddress, setSelectedAddress] = useState(null);
//     const [suggestions, setSuggestions] = useState([]);
//     const [error, setError] = useState('');

//     // When user types manually (and no suggestion is selected), call onAddressSelect with a full address object.
//     useEffect(() => {
//         if (!selectedAddress) {
//             const manualAddress = {
//                 building: addressInput || "",
//                 apt: "",
//                 city: "",
//                 state: "",
//                 zip: "",
//                 lat: null,
//                 lon: null,
//             };
//             onAddressSelect(manualAddress);
//         }
//     }, [addressInput, selectedAddress, onAddressSelect]);

//     // Debounced fetch for suggestions
//     useEffect(() => {
//         const delayDebounceFn = setTimeout(() => {
//             if (addressInput.trim() !== '') {
//                 fetchSuggestions(addressInput);
//             } else {
//                 setSuggestions([]);
//             }
//         }, 500);
//         return () => clearTimeout(delayDebounceFn);
//     }, [addressInput]);

//     const fetchSuggestions = async (input) => {
//         try {
//             const response = await fetch(`${backendUrl}/address/check`, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({ address: input })
//             });
//             const data = await response.json();
//             if (!response.ok) {
//                 setError(data.message || 'Error verifying address');
//                 setSuggestions([]);
//             } else {
//                 setSuggestions(data.data);
//                 setError('');
//             }
//         } catch (err) {
//             setError('Error: ' + err.message);
//             setSuggestions([]);
//         }
//     };

//     const handleSelectSuggestion = (sug) => {
//         const parsedAddress = {
//             building: sug.formatted_address || sug.building || sug.street || "",
//             city: sug.city || "",
//             state: sug.state || "",
//             zip: sug.zip || "",
//             lat: sug.lat !== undefined ? sug.lat : null,
//             lon: sug.lon !== undefined ? sug.lon : null,
//             apt: "",
//         };
//         setSelectedAddress(parsedAddress);
//         onAddressSelect(parsedAddress);
//         setAddressInput(sug.formatted_address || parsedAddress.building);
//         setSuggestions([]);
//     };

//     const inputProps = {
//         style: { fontSize: fontSizeVariant === 'small' ? '0.75rem' : undefined },
//     };

//     const inputLabelProps = {
//         style: { fontSize: fontSizeVariant === 'small' ? '0.75rem' : undefined },
//     };

//     return (
//         <div>
//             <div className={classes.formField}>
//                 <TextField
//                     variant="outlined"
//                     label="Building Address"
//                     fullWidth
//                     value={addressInput}
//                     onChange={(e) => {
//                         setAddressInput(e.target.value);
//                         setSelectedAddress(null);
//                     }}
//                     placeholder="Enter building address"
//                     InputProps={inputProps}
//                     InputLabelProps={inputLabelProps}
//                 />
//             </div>
//             {error && (
//                 <Typography variant="body2" color="error" className={classes.errorText}>
//                     {error}
//                 </Typography>
//             )}
//             {suggestions.length > 0 && (
//                 <Paper variant="outlined">
//                     <List dense>
//                         {suggestions.map((sug, index) => (
//                             <ListItem
//                                 button
//                                 key={index}
//                                 onClick={() => handleSelectSuggestion(sug)}
//                                 style={{ fontSize: fontSizeVariant === 'small' ? '0.75rem' : 'inherit' }}
//                             >
//                                 {sug.formatted_address || sug.building || ""}
//                             </ListItem>
//                         ))}
//                     </List>
//                 </Paper>
//             )}
//         </div>
//     );
// };

// export default AddressCheck;







import React, { useState, useEffect } from 'react';
import { backendUrl } from './config';
import { makeStyles } from '@mui/styles';
import { TextField, Typography, Paper, List, ListItem } from '@mui/material';

const useStyles = makeStyles(() => ({
  formField: {
    marginBottom: '8px !important',
    width: '100%',
  },
  errorText: {
    fontSize: (props) => (props.fontSizeVariant === 'small' ? '0.75rem' : '0.85rem'),
    marginTop: '4px',
  },
}));

const AddressCheck = ({ onAddressSelect, onError = () => {}, fontSizeVariant = 'regular', initialAddress = '' }) => {
  const classes = useStyles({ fontSizeVariant });
  const [addressInput, setAddressInput] = useState(initialAddress);
  const [cityInput, setCityInput] = useState('');
  const [stateInput, setStateInput] = useState('');
  const [zipInput, setZipInput] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [error, setError] = useState('');
  const [manualMode, setManualMode] = useState(false);

  // Debounced fetch for suggestions
  useEffect(() => {
    const timer = setTimeout(() => {
      if (addressInput.trim()) {
        fetchSuggestions(addressInput);
      } else {
        setSuggestions([]);
        setError('');
        setManualMode(false);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [addressInput]);

  const fetchSuggestions = async (input) => {
    try {
      const response = await fetch(`${backendUrl}/address/check`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ address: input }),
      });
      const data = await response.json();
      if (!response.ok) {
        setError(
          'Please enter the building address here, and complete the remaining fields below.'
        );
        setSuggestions([]);
        setManualMode(true);
        onError();
      } else {
        setSuggestions(data.data || []);
        setError('');
        setManualMode(false);
      }
    } catch (err) {
      setError(
        'Please enter the building address here, and complete the remaining fields below.'
      );
      setSuggestions([]);
      setManualMode(true);
      onError();
    }
  };

  const handleSelectSuggestion = (sug) => {
    const parsed = {
      building: sug.formatted_address || sug.building || sug.street || '',
      city: sug.city || '',
      state: sug.state || '',
      zip: sug.zip || '',
      lat: sug.lat ?? null,
      lon: sug.lon ?? null,
      apt: '',
    };
    setAddressInput(parsed.building);
    setCityInput(parsed.city);
    setStateInput(parsed.state);
    setZipInput(parsed.zip);
    setSuggestions([]);
    setError('');
    setManualMode(false);
    onAddressSelect(parsed);
  };

  // Notify parent of manual fields when in manual mode
  useEffect(() => {
    if (manualMode) {
      onAddressSelect({
        building: `${addressInput}, ${cityInput}, ${stateInput}, ${zipInput}`,
        apt: '',
        city: cityInput,
        state: stateInput,
        zip: zipInput,
        lat: null,
        lon: null,
      });
    }
  }, [addressInput, cityInput, stateInput, zipInput, manualMode, onAddressSelect]);

  const fontSizeStyle = fontSizeVariant === 'small' ? { fontSize: '0.75rem' } : {};

  return (
    <div>
      <TextField
        variant="outlined"
        label="Building Address"
        fullWidth
        value={addressInput}
        onChange={(e) => setAddressInput(e.target.value)}
        placeholder="Enter building address"
        InputProps={{ style: fontSizeStyle }}
        InputLabelProps={{ style: fontSizeStyle }}
        className={classes.formField}
      />

      {error && (
        <Typography variant="body2" className={classes.errorText}>
          {error}
        </Typography>
      )}

      {!manualMode && suggestions.length > 0 && (
        <Paper variant="outlined" className={classes.formField}>
          <List dense>
            {suggestions.map((sug, idx) => (
              <ListItem
                button
                key={idx}
                onClick={() => handleSelectSuggestion(sug)}
                style={fontSizeStyle}
              >
                {sug.formatted_address || sug.building}
              </ListItem>
            ))}
          </List>
        </Paper>
      )}

      {manualMode && (
        <>
          <TextField
            variant="outlined"
            label="City"
            fullWidth
            value={cityInput}
            onChange={(e) => setCityInput(e.target.value)}
            placeholder="Enter city"
            InputProps={{ style: fontSizeStyle }}
            InputLabelProps={{ style: fontSizeStyle }}
            className={classes.formField}
          />
          <TextField
            variant="outlined"
            label="State"
            fullWidth
            value={stateInput}
            onChange={(e) => setStateInput(e.target.value)}
            placeholder="Enter state"
            InputProps={{ style: fontSizeStyle }}
            InputLabelProps={{ style: fontSizeStyle }}
            className={classes.formField}
          />
          <TextField
            variant="outlined"
            label="Zip Code"
            fullWidth
            value={zipInput}
            onChange={(e) => setZipInput(e.target.value)}
            placeholder="Enter zip code"
            InputProps={{ style: fontSizeStyle }}
            InputLabelProps={{ style: fontSizeStyle }}
            className={classes.formField}
          />
        </>
      )}
    </div>
  );
};

export default AddressCheck;





















